import {reducer as formReducer} from 'redux-form';
import routing from './routing';
import combine from './combine';
import asyncCounters from '~/modules/asyncCounters/reducer';
import search from '~/modules/loadsSearch/reducer';
import geosearch from '~/modules/geosearch/reducer';
import user from '~/modules/user/reducer';
import recentSearches from '~/modules/recentSearches/reducer';
import loads from '~/modules/loads/reducer';
import brokers from '~/modules/brokers/reducer';
import similarLoads from '~/modules/similarLoads/reducer';
import places from '~/modules/places/reducer';
import {normalizeForm as normalizeSearchForm} from '../misc/search';
import tabs from '~/modules/tabs/reducer';
import dropdowns from '~/modules/dropdowns/reducer';
import modal from '~/modules/modal/reducer';
import toast from '~/modules/toast/reducer';
import tips from '~/modules/tips/reducer';
import now from '~/modules/now/reducer';
import installation from '~/modules/installation/reducer';
import meta from '~/modules/meta/reducer';
import window from '~/modules/window/reducer';
import backhaul from '~/modules/backhaul/reducer';
import bids from '~/modules/bids/reducer';
import introduction from '~/modules/introduction/reducer';
import resources from '~/modules/resources/reducer';
import account from '~/modules/account/reducer';
import userAccountPage from '~/modules/userAccountPage/reducer';
import adminAccountPage from '~/modules/adminAccountPage/reducer';
import paymentHistoryPage from '~/modules/paymentHistoryPage/reducer';
import accountProfilePage from '~/modules/accountProfilePage/reducer';
import paymentSettingPage from '~/modules/paymentSettingPage/reducer';
import myLoads from '~/modules/myLoads/reducer';
import hp from '~/modules/hp/reducer';
import hideConfirm from '~/modules/hideConfirm/reducer';
import myCompany from '~/modules/myCompany/reducer';
import dots from '~/modules/dots/reducer';
import alert from '~/modules/alert/reducer';
import verifyEmail from '~/modules/verify/reducer';
import rate from '~/modules/rate/reducer';
import premiumSwitch from '~/modules/premiumSwitch/reducer';
import createAccount from '~/modules/createAccount/reducer';
import customerServicePaymentProcess from '~/modules/customerServicePaymentProcess/reducer';
import detailsPageLoads from '~/modules/loadDetails/reducer';
import capacityRatio from '~/modules/cityRatio/reducer'
import bookings from "~/modules/bookings/reducer";
import cityRatioList from '~/modules/cityRatioList/reducer'
import payment from "~/modules/payment/reducer";

import postTruck from '~/pages/PostTruck/state/reducer';
import messagePush from '~/pages/MessagePush/state/reducer'

import fuelSurcharge from '~/pages/FuelSurchargePage/state/reducer'
const updater = (fn, initialState) => ({fn, initialState});

export default combine({
  form: formReducer.normalize({
    search: normalizeSearchForm,
    alert: normalizeSearchForm
  }),
  detailsPageLoads: updater(detailsPageLoads.reducer, detailsPageLoads.initialState),
  toast: updater(toast.reducer, toast.initialState),
  tips: updater(tips.reducer, tips.initialState),
  installation: updater(installation.reducer, installation.init()),
  meta: updater(meta.reducer, meta.initialState),
  routing: updater(routing.reducer, routing.initialState),
  asyncCounters: updater(asyncCounters.reducer, asyncCounters.initialState),
  tabs: updater(tabs.reducer, tabs.initialState),
  dropdowns: updater(dropdowns.reducer, dropdowns.initialState),
  user: updater(user.reducer, user.init()),
  dots: updater(dots.reducer, dots.initialState),
  verifyEmail: updater(verifyEmail.reducer, verifyEmail.initialState),
  premiumSwitch: updater(premiumSwitch.reducer, premiumSwitch.initialState),
  loadsSearch: updater(search.reducer, search.initialState),
  geosearch: updater(geosearch.reducer, geosearch.initialState),
  places: updater(places.reducer, places.initialState),
  recentSearches: updater(recentSearches.reducer, recentSearches.initialState),
  loads: updater(loads.reducer, loads.init()),
  brokers: updater(brokers.reducer, brokers.initialState),
  backhaul: updater(backhaul.reducer, backhaul.initialState),
  bids: updater(bids.reducer, bids.init()),
  introduction: updater(introduction.reducer, introduction.init()),
  similarLoads: updater(similarLoads.reducer, similarLoads.initialState),
  modal: updater(modal.reducer, modal.initialState),
  now: updater(now.reducer, now.initialState),
  resources: updater(resources.reducer, resources.initialState),
  window: updater(window.reducer, window.init()),
  alert: updater(alert.reducer, alert.init()),
  account: updater(account.reducer, account.initialState),
  userAccountPage: updater(userAccountPage.reducer, userAccountPage.initialState),
  adminAccountPage: updater(adminAccountPage.reducer, adminAccountPage.initialState),
  paymentHistoryPage: updater(paymentHistoryPage.reducer, paymentHistoryPage.initialState),
  accountProfilePage: updater(accountProfilePage.reducer, accountProfilePage.initialState),
  paymentSettingPage: updater(paymentSettingPage.reducer, paymentSettingPage.initialState),
  payment: updater(payment.reducer, payment.initialState),
  myLoads: updater(myLoads.reducer, myLoads.init()),
  hp: updater(hp.reducer, hp.initialState),
  hideConfirm: updater(hideConfirm.reducer, hideConfirm.initialState),
  myCompany: updater(myCompany.reducer, myCompany.initialState),
  createAccount: updater(createAccount.reducer, createAccount.initialState),
  customerServicePaymentProcess: updater(
    customerServicePaymentProcess.reducer,
    customerServicePaymentProcess.initialState),
  rate: updater(rate.reducer, rate.initialState),
  capacityRatio: updater(capacityRatio.reducer, capacityRatio.init()),
  cityRatioList:updater(cityRatioList.reducer, cityRatioList.initialState),
  postTruck: updater(postTruck.reducer, postTruck.init()),
  bookings: updater(bookings.reducer, bookings.init()),
  messagePush: updater(messagePush.reducer, messagePush.init()),
  fuelSurcharge: updater(fuelSurcharge.reducer, fuelSurcharge.init())
});

/*
when we switch everything to modules:

import mapValues from 'lodash/mapValues';
import reducer from '../module/reducer';

const updater = ({reducer, initialState}) =>
 (state = initialState, action) =>
    ({...state, ...(reducer(state, action) || {})});

const reducers = mapValues({
  reducer,
}, updater);

export default combineReducers({
 form: formReducer.normalize({
   search: normalizeSearchForm,
 }),
 ...reducers
};
 */



// WEBPACK FOOTER //
// ./src/reducers/index.js